import React from "react";
import Tile from "./components/Tile";
import Slider from "react-slick";
import BannerArrow from "./components/BannerArrow.jsx";
import Dots from "./components/Dots.js";
import "./TopSalesBanner.scss";

class TopSalesBanner extends React.Component {
  state = {
    sales: {},
    flowDirection: "",
  };

  componentDidMount() {
    this.setState({ sales: this.props.top_sales });

    this.removeMargin();
    const carousel = document.getElementById("top-sales");
    carousel.addEventListener("touchstart", this.touchStart);
    carousel.addEventListener("touchmove", this.preventTouch, {
      passive: false,
    });
  }

  setDirection = (flowDirection) => {
    this.setState({ flowDirection });
  };

  handleSwipe = (direction) => {
    this.setDirection(direction);
    setTimeout(() => this.setDirection(""), 400);
  };

  removeMargin = () => {
    const banners = [
      ".promotion_banner",
      ".promotional-banners",
      ".myus-banner",
    ];
    const bannerExists = banners.some((name) => {
      const banner = document.querySelector(name);
      return banner != null;
    });

    if (!bannerExists) {
      document
        .getElementById("top-sales")
        .classList.add("top-sales-no-margin-top");
    }
  };

  touchStart = (e) => {
    this.firstClientX = e.touches[0].clientX;
  };

  preventTouch = (e) => {
    const clientX = e.touches[0].clientX - this.firstClientX;
    const horizontalScroll = Math.abs(clientX) > 5;
    if (horizontalScroll && e.cancelable) {
      e.preventDefault();
    }
  };

  render() {
    const settings = {
      dots: false,
      speed: 400,
      infinite: true,
      lazyload: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      nextArrow: (
        <BannerArrow
          setDirection={this.setDirection}
          arrowDirection="right"
          flowDirection="left"
        />
      ),
      prevArrow: (
        <BannerArrow
          setDirection={this.setDirection}
          arrowDirection="left"
          flowDirection="right"
        />
      ),
      onSwipe: this.handleSwipe,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
      waitForAnimate: false,
    };

    const sales = this.state.sales;

    return (
      <div id="top-sales" className="top-sales">
        {sales.length >= 4 && (
          <div className="top-sales-banner">
            <div className="top-sales-section-header">TOP SALES</div>
            <Slider {...settings}>
              {Object.keys(this.state.sales).map((key) => (
                <Tile key={key} details={this.state.sales[key]} />
              ))}
            </Slider>
            <Dots flowDirection={this.state.flowDirection} />
          </div>
        )}
      </div>
    );
  }
}

export default TopSalesBanner;
